<template>
  <app-layout>

    <h2><i class="icon-cogs"/> Settings</h2>

    <div class='clearfix'></div>
    <br>

    <div class='formBox'>

      <v-select :items="[1,2,3]" label="Dein Level" prefix="Level: " v-model="settings.level"/>

      <v-select :items="[0,1,2,3,4,5]" label="Tag endet um:" suffix="Uhr" v-model="settings.day_ends_at"></v-select>

      <v-select :items="[0,1,2,3,4,5]" label="Countdown:" suffix="Sekunden" v-model="settings.countdown"></v-select>

      <v-select :items="['light','dark']" label="App-Style" prefix="Style: " v-model="settings.app_style"></v-select>

      <br>

      <v-btn large block color="success" type="submit" v-text="'Speichern'" @click="updateSettings"/>

      <template v-if="activeWorkout">
        <br>
        <hr class="seventy" />
        <br>
        <router-link to="workout" class="box">
          <img :src="activeWorkout.plan.image_url" class="responsive" />
        </router-link>
        <v-btn block color="error" v-text="'Workout stoppen'" @click="stopWorkout"/>
        <br>
        <br>
        <br>
      </template>

    </div>

    <template v-if="3 === 4" slot="bottomx">
      <div class="brow justify-content-center">
      <div :class="linkCol" v-if="activeWorkout">
        <router-link to="workout" class="box">
          <img :src="activeWorkout.plan.image_url" class="responsive" />
          <hr class="half-press"/>
          Aktiver Workout
        </router-link>
      </div>
      <div :class="linkCol">
        <router-link to="workouts" class="box big-icn">
          <i class="icon-accessibility"></i>
          all Workouts
        </router-link>
      </div>
    </div>
      <div class="brow justify-content-center">
        <div :class="linkCol">
          <a @click="resetData" class="box big-icn dngr no-press">
            <i class="icon-warning"></i>
            reset Data
          </a>
        </div>
      </div>
      <v-btn large color="error" outline>
        <i class="icon-warning"></i>&nbsp;
        reset Data
      </v-btn>
    </template>

    <div class='clearfix'></div>
    <br>
    <hr>
    <span class="gray mt-2">App-Version: <b>{{ appVersion }}</b></span>
    <hr>
    <br>

    <div class='formBox px-5'>

      <div v-for="lnk in settingLinks" :key="'setLnk'+ lnk.icon">
        <v-btn large block @click="lnk.action">
          <i :class="'loud icon-' + lnk.icon"></i>
          &nbsp;&nbsp;&nbsp;
          <span>{{ lnk.name }}</span>
        </v-btn>
        <br>
      </div>

    </div>

    <v-bottom-nav :value="true" fixed v-if="3 === 4">
      <v-btn to="/">
        <span>Home</span>
        <i class="icon-home"></i>
      </v-btn>
      <v-btn to="/workouts">
        <span>All Workouts</span>
        <i class="icon-accessibility"></i>
      </v-btn>
      
    </v-bottom-nav>
    <bottom-nav />

    

  </app-layout>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue';
import FullBox from '@/components/ui/FullBox.vue';
import BottomNav from '@/components/layout/BottomNav';
import { mapGetters } from 'vuex';
import SportBG from '@/assets/images/sports.png';

export default {
  name: 'Settings',
  data() {
    return {
      linkCol:    'col-6 col-sm-4 col-lg-3',
      appStyles:  ['dark','light'],
      saved:      false,
      settings: {
        level:        null,
        day_ends_at:  null,
        countdown:    null,
        app_style:    null
      },
      settingLinks: [
        { name: "Reload Workouts", action: this.reloadData, icon: "cloud-download" },
        { name: "Reload App", action: this.reloadApp, icon: "switch" },
        { name: "Reset Data", action: this.resetData, icon: "warning" }
      ]
    }
  },
  mounted(){
    this.settings = {
      level:        this.currentUser.level,
      day_ends_at:  this.currentUser.day_ends_at,
      countdown:    this.currentUser.countdown,
      app_style:    this.currentUser.app_style
    }
  },
  components: {
    FullBox,
    BottomNav
  },
  computed: {
    ...mapGetters(["currentUser", "activeWorkout"]),
    appVersion() {
      const packageJSON = require('./../../package.json')
      let APPversion = (packageJSON && packageJSON.version) ? packageJSON.version : "x.x.x"
      console.log("appVersion", process.env, APPversion )
      return APPversion
    }
  },
  methods: {
    resetData() {
      if (confirm(`Reset Bestättigen!\n\nWillst Du wirklich alle Daten auf deinem Gerät löschen?\n\nAktive- und Eigene-Workouts werden dadurch auch gelöscht.`)) {
        localStorage.removeItem('store')
        this.$store.dispatch('resetData')
        this.$router.push('/')
      }
    },
    updateSettings() {
      this.saved = true
      this.$store.dispatch('updateSettings', this.settings )
    },
    levelText(item) {
      return 'Level ' + item
    },
    stopWorkout() {
      if (confirm(`Beenden Bestättigen!\n\nWorkout:  ${ this.activeWorkout.plan.name }\n\nWillst Du diesen Workout wirklich beenden?`)) {
        this.$store.dispatch('unsetActiveWorkout')
      }
    },
    reloadData() {
      this.$store.dispatch('getPlans');
    },

    reloadApp() {
      window.location.reload(true);
    },
  }
};
</script>

<style lang="scss">
#settings {
  // background: transparent url('../assets/images/sports_blur.png') left top repeat;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAANklEQVQoU2NkwAPu3r37nxGXPEhSWVmZEasCmCRIM4YCZEkMBeiSKAqwScIV4JIEK8AnCVIAABoiH59e1lDMAAAAAElFTkSuQmCC) #fbfbfb;
}

.formBox {
  width: 80%;
  max-width: 500px;
  margin: 0 auto;
}

</style>
